/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeADownRightIcon20Solid = forwardRef('ArrowShapeADownRightIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M14.75 17A2.25 2.25 0 0 0 17 14.75V4.573c0-1.202-1.454-1.805-2.304-.954l-2.117 2.117-3.352-3.351a2 2 0 0 0-2.828 0L2.386 6.398a2 2 0 0 0 0 2.828l3.35 3.352-2.117 2.117c-.85.85-.248 2.305.955 2.305H14.75Z" })));
});
